import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraICTService } from '../../models/doraICTService.ts';

interface DoraICTServiceState {
  doraICTServices: DoraICTService[];
  selectedDoraICTService: DoraICTService | null;
}

const initialState: DoraICTServiceState = {
  doraICTServices: [],
  selectedDoraICTService: null,
};

const doraICTServiceSlice = createSlice({
  name: 'doraICTService',
  initialState,
  reducers: {
    setDoraICTServices(state, action: PayloadAction<DoraICTService[]>) {
      state.doraICTServices = action.payload;
    },
    addDoraICTService(state, action: PayloadAction<DoraICTService>) {
      state.doraICTServices.push(action.payload);
    },
    updateDoraICTService(state, action: PayloadAction<DoraICTService>) {
      const index = state.doraICTServices.findIndex(service => service.id === action.payload.id);
      if (index !== -1) state.doraICTServices[index] = action.payload;
    },
    removeDoraICTService(state, action: PayloadAction<number>) {
      state.doraICTServices = state.doraICTServices.filter(service => service.id !== action.payload);
    },
    setSelectedDoraICTService(state, action: PayloadAction<DoraICTService | null>) {
      state.selectedDoraICTService = action.payload;
    },
  },
});

export const {
  setDoraICTServices,
  addDoraICTService,
  updateDoraICTService,
  removeDoraICTService,
  setSelectedDoraICTService,
} = doraICTServiceSlice.actions;

export const selectDoraICTServices = (state: RootState) => state.doraICTService.doraICTServices;
export const selectSelectedDoraICTService = (state: RootState) => state.doraICTService.selectedDoraICTService;

export default doraICTServiceSlice.reducer;
